<template>
  <section class="mb-0" id="future">
    <div class="future__wrapper">
      <div class="future">
        <img
          class="future__book"
          src="@/assets/images/new/rewolucyjna_books.png"
        />
        <div class="future__content">
          <h2 class="future__title">
            Przyszłość będzie taka, jaką sobie zgotujemy
          </h2>
          <div class="future__desc">
            Wypróbuj <b>70 roślinnych przepisów z </b>
            <i>Rewolucyjnej książki kucharskiej</i>. <br /><br />
            Gotuj, smakuj, obliż palce i przewróć stronę, po 19 fascynujących
            rozmów z osobami ze świata nauki i aktywizmu.
          </div>
        </div>
      </div>
    </div>

      <SliderBook />
 
    <div class="future__bottom">
      <div class="btnK" @click="openInvitation">Zamów książkę</div>
    </div>
  </section>
</template>
<script>
import SliderBook from "@/components/elements/SliderBook";
export default {
  text: "Future",
  components: { SliderBook },
  methods: {
    openInvitation() {
      this.$root.$emit("toggleModalInvitation", true);
    },
  },
};
</script>
